import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function updateFSVersionInLocation(locationId, oemReference, dealerCodeFS, oemVersion, newFSVersion) {
	if (locationId) {
		const query = gql`
			mutation updateFSVersionInLocation(
				$locationId: String!
				$oemReference: String!
				$dealerCodeFS: String
				$oemVersion: String
				$newFSVersion: String
			) {
				updateFSVersionInLocation(
					locationId: $locationId
					oemReference: $oemReference
					dealerCodeFS: $dealerCodeFS
					oemVersion: $oemVersion
					newFSVersion: $newFSVersion
				) {
					oemReference
					dealerCodeFS
					versions {
						_id
						financialStatements {
							version
							pages {
								pageName
								pageNumber
								pageRelations {
									franchise
								}
								content
								_id
							}
						}
					}
				}
			}
		`;

		const variables = {
			locationId: locationId,
			oemReference: oemReference,
			dealerCodeFS: dealerCodeFS,
			oemVersion: oemVersion,
			newFSVersion: newFSVersion,
		};

		try {
			const response = await apiInstance.post("/graphql", { query, variables });
			return response;
		} catch (err) {
			errorLogger(err);
			return null;
		}
	}
}

export async function updateFSAccountMappingConfig(locationId, input) {
	if (locationId) {
		const query = gql`
			mutation updateFSAccountMappingConfig($locationId: String!, $input: FSConfigAccountMappingInput) {
				updateFSAccountMappingConfig(locationId: $locationId, input: $input) {
					locationId
					oemReference
					dealerCodeFS
					oemVersion
					fsVersion
					pageNumber
					account {
						_id
						account
						label
						relations {
							_id
							subAccount
							glAccountValue
							accountType
							GLIndex
							typeError {
								glAccount
								expectedType
								currentType
							}
							warning
							error
							hideInput
						}
					}
				}
			}
		`;

		const variables = {
			locationId: locationId,
			input: input,
		};

		try {
			const response = await apiInstance.post("/graphql", { query, variables });
			return response;
		} catch (err) {
			errorLogger(err);
			return null;
		}
	}
}

export async function saveGLAccountsFromPrevVersion(locationId, input) {
	if (locationId) {
		const query = gql`
			mutation saveGLAccountsFromPrevVersion($locationId: String!, $input: SaveGLAccountsInput) {
				saveGLAccountsFromPrevVersion(locationId: $locationId, input: $input) {
					locationId
					oemReference
					dealerCodeFS
					versions {
						_id
						financialStatements {
							version
							pages {
								pageName
								pageNumber
								pageRelations {
									franchise
								}
								content
								_id
							}
						}
					}
				}
			}
		`;

		const variables = {
			locationId: locationId,
			input: input,
		};

		try {
			const response = await apiInstance.post("/graphql", { query, variables });
			return response;
		} catch (err) {
			errorLogger(err);
			return null;
		}
	}
}
